'use strict';

exports.__esModule = true;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactRedux = require('react-redux');

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _clinics = require('@vezeeta/enterprise-store/lib/actions/clinics');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

var ClinicsContainer = function ClinicsContainer(_ref) {
  var props = _objectWithoutProperties(_ref, []);

  var language = props.language;

  (0, _react.useEffect)(function () {
    if (language) props.loadClinics(language);
  }, [language]);

  return _react2.default.createElement(
    _react.Fragment,
    null,
    props.children
  );
};

ClinicsContainer.propTypes = process.env.NODE_ENV !== "production" ? {
  loadClinics: _propTypes2.default.func.isRequired,
  children: _propTypes2.default.object.isRequired,
  language: _propTypes2.default.string.isRequired
} : {};

var mapStateToProps = function mapStateToProps(state) {
  return {
    clinicsLoading: state.clinics.loading,
    countries: state.country.Countries,
    clinics: state.clinics.Clinics,
    user: state.user.user,
    isUserLoaded: state.user.loaded
  };
};

var mapDispatchToProps = function mapDispatchToProps(dispatch) {
  return {
    loadClinics: function loadClinics(language) {
      return dispatch((0, _clinics.loadClinics)(language));
    }
  };
};

exports.default = (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps)(ClinicsContainer);
module.exports = exports['default'];